<template lang="pug">
.header
  a(href="https://epoca.health/" target="_blank")
    Logo.logo(:height="35" :withText="true")
</template>

<script>
export default {}
</script>

<style lang="stylus">
.header
  width 100%
  height 60px
  background-color var(--white, #FFFFFF)
  display flex
  align-items center
  position fixed
  z-index 1
  max-width 1200px
  margin auto
  .logo
    padding-top 8px
    padding-left 4px
</style>
